import script from "./orderinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./orderinfo.vue?vue&type=script&setup=true&lang=js"

import "./orderinfo.vue?vue&type=style&index=0&id=be88f93a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be88f93a"]])

export default __exports__